import { render, staticRenderFns } from "./MenuItems.vue?vue&type=template&id=cfaf21b8"
import script from "./MenuItems.vue?vue&type=script&lang=js"
export * from "./MenuItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports